import { webKnots } from '../../../common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const wt2Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  // 左
  ctx.moveTo(591, 113) // 左上
  ctx.quadraticCurveTo(564, 125, 538, 153) //
  ctx.quadraticCurveTo(530, 160, 532, 181) //
  ctx.quadraticCurveTo(536, 209, 508, 247) // 一番下
  ctx.quadraticCurveTo(535, 236, 536, 222) //
  ctx.quadraticCurveTo(542, 210, 539, 170) //
  ctx.quadraticCurveTo(535, 154, 595, 117) //
  ctx.quadraticCurveTo(591, 113, 591, 113) //
  // 右
  ctx.moveTo(543, 278) // 左下
  ctx.quadraticCurveTo(550, 288, 550, 288) //
  ctx.quadraticCurveTo(597, 296, 597, 296) //
  ctx.quadraticCurveTo(664, 289, 664, 289) // 右上
  ctx.quadraticCurveTo(626, 263, 626, 263) //
  ctx.quadraticCurveTo(610, 274, 610, 274) //
  ctx.quadraticCurveTo(599, 280, 599, 280) //
  ctx.quadraticCurveTo(557, 274, 557, 274) //
  ctx.quadraticCurveTo(543, 278, 543, 278) //
  // 革紐部分
  ctx.moveTo(664, 208) // 右上
  ctx.quadraticCurveTo(588, 227, 588, 227) //
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(587, 109, 587, 109) // 左上
  ctx.quadraticCurveTo(554, 126, 537, 147) //
  ctx.quadraticCurveTo(525, 160, 528, 182) //
  ctx.quadraticCurveTo(532, 209, 498, 252) //
  ctx.quadraticCurveTo(521, 253, 540, 227) //
  ctx.quadraticCurveTo(546, 199, 542, 170) //
  ctx.quadraticCurveTo(543, 153, 600, 120) //
  ctx.quadraticCurveTo(605, 125, 605, 125) //
  ctx.quadraticCurveTo(568, 142, 549, 168) //
  ctx.quadraticCurveTo(552, 184, 549, 218) //
  ctx.quadraticCurveTo(635, 158, 635, 158) // 上
  ctx.quadraticCurveTo(640, 165, 640, 165) //
  ctx.quadraticCurveTo(507, 263, 507, 263) //
  ctx.quadraticCurveTo(514, 270, 514, 270) //
  ctx.quadraticCurveTo(535, 254, 535, 254) //
  ctx.quadraticCurveTo(596, 256, 596, 256) //
  ctx.quadraticCurveTo(677, 238, 677, 238) // 上
  ctx.quadraticCurveTo(667, 215, 667, 215) //
  ctx.quadraticCurveTo(584, 236, 584, 236) // 下＿右
  ctx.quadraticCurveTo(582, 222, 582, 222) // 下＿左
  ctx.quadraticCurveTo(661, 200, 661, 200) //
  ctx.quadraticCurveTo(640, 165, 640, 165) //
  ctx.moveTo(676, 237)
  ctx.quadraticCurveTo(689, 277, 689, 277) //
  ctx.moveTo(634, 156)
  ctx.quadraticCurveTo(582, 136, 582, 136) //
  ctx.quadraticCurveTo(597, 181, 597, 181) //
  ctx.quadraticCurveTo(553, 163, 553, 163) //
  ctx.moveTo(535, 277) // 左下
  ctx.quadraticCurveTo(548, 292, 548, 292) //
  ctx.quadraticCurveTo(598, 301, 598, 301) //
  ctx.quadraticCurveTo(665, 294, 665, 294) //
  ctx.quadraticCurveTo(675, 287, 675, 287) //
  ctx.quadraticCurveTo(625, 255, 625, 255) //
  ctx.quadraticCurveTo(600, 274, 600, 274) //
  ctx.quadraticCurveTo(557, 268, 557, 268) //
  ctx.quadraticCurveTo(535, 277, 535, 277) //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
  crossLace(ctx, laceColor, 25, -7)
  crossLace(ctx, laceColor, -5, 2)
  ctx.beginPath()
  ctx.moveTo(649, 197) // 左上
  ctx.quadraticCurveTo(655, 206, 660, 225) // 左下
  ctx.quadraticCurveTo(664, 226, 667, 222) // 右下
  ctx.quadraticCurveTo(665, 204, 657, 194) // 右上
  ctx.quadraticCurveTo(649, 191, 649, 197) // 右上
  ctx.fill()
  ctx.moveTo(649, 195) // 左上
  ctx.quadraticCurveTo(659, 206, 662, 225) // 左下
  ctx.stroke()
  ctx.closePath()
  webKnots(ctx, laceColor, -50, 10, 1) //
}

const crossLace = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  // 右上＿左下
  ctx.beginPath()
  ctx.moveTo(613 + x, 207 + y) // 左上
  ctx.quadraticCurveTo(598 + x, 243 + y, 598 + x, 243 + y) // 左下
  ctx.quadraticCurveTo(607 + x, 244 + y, 611 + x, 235 + y) // 右下
  ctx.quadraticCurveTo(623 + x, 203 + y, 623 + x, 203 + y) // 右上
  ctx.quadraticCurveTo(616 + x, 200 + y, 613 + x, 207 + y) // 右上
  ctx.fill()
  ctx.moveTo(613 + x, 207 + y) // 左上
  ctx.quadraticCurveTo(608 + x, 231 + y, 598 + x, 243 + y) // 左下
  ctx.stroke()
  ctx.closePath()
  // 左上＿右下
  ctx.beginPath()
  ctx.moveTo(597 + x, 209 + y) // 左上
  ctx.quadraticCurveTo(620 + x, 237 + y, 620 + x, 237 + y) // 左下
  ctx.quadraticCurveTo(625 + x, 238 + y, 627 + x, 233 + y) // 右下
  ctx.quadraticCurveTo(619 + x, 218 + y, 605 + x, 206 + y) // 右上
  ctx.quadraticCurveTo(601 + x, 205 + y, 597 + x, 209 + y) // 左上
  ctx.fill()
  ctx.moveTo(597 + x, 209 + y) // 左上
  ctx.quadraticCurveTo(611 + x, 221 + y, 620 + x, 237 + y) // 左下
  ctx.stroke()
  ctx.closePath()
}
